import {
    bexHttpClient
} from '../../clients';
import {
    GetLLMModelsRequest,
    GetLLMModelsResponse
} from '../bexService.types';

/**
 * Service class for performing model operations.
 */
class ModelService {
    /**
     * Gets LLM models from various providers.
     * @param {GetLLMModelsRequest} data - The request data containing provider filters.
     * @param {boolean} hardRefresh - Whether to force refresh the models cache.
     * @param {string} organizationId - Organization whose enabled providers gate the catalog.
     * @returns {Promise<GetLLMModelsResponse>} The response containing the list of models.
     */
    async getModels(data: GetLLMModelsRequest, hardRefresh = false, organizationId?: string): Promise<GetLLMModelsResponse> {
        const query = new URLSearchParams({ hardRefresh: String(hardRefresh) });
        if (organizationId) {
            query.set('organizationId', organizationId);
        }
        const response = await bexHttpClient.post(`/llm/models/get-llm-models?${query.toString()}`, data);
        return response;
    }
}

const modelService = new ModelService();
export { modelService };